module.exports = __webpack_public_path__ + "static/media/advasonic-3.42b7a16f.png";